import { Navigation2 } from 'react-feather';
import Text from '../atoms/Text';
import { useState, useEffect, useRef } from 'react';
import Image from 'next/image';
import { getAuth } from '@/services/auth.service';

const TooltipWithArrow = ({
    childNode,
    tooltipText, // hover tooltip
    rightClickContent, // NEW → right-click tooltip content (can be JSX)
    className,
    tooltipClass,
    tooltipPositionClass = 'right-[54px] top-0.5',
    tooltipTextClass = 'text-nowrap',
    arrowClass,
    onClick,
    isRightClick,
    onContextContentClick
}) => {
    const auth = getAuth();
    const isSuperAdmin = auth?.role === 'SuperAdmin';
    const [showContext, setShowContext] = useState(false);
    const wrapperRef = useRef();

    const handleRightClick = (e) => {
        if (!isRightClick || !isSuperAdmin) return;
        e.preventDefault();
        setShowContext(true);
    };

    // close on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setShowContext(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <div
            ref={wrapperRef}
            className={`relative group ${className}`}
            onClick={onClick}
            onContextMenu={handleRightClick}
        >
            {childNode}

            {/* HOVER TOOLTIP */}
            <div
                className={`absolute hidden group-hover:block bg-gray-600 rounded ${tooltipPositionClass} ${tooltipClass}`}
            >
                <div className="relative">
                    <Text variant='caption' className={`text-basic-100 px-2 py-1.5 ${tooltipTextClass}`}>
                        {tooltipText}
                    </Text>
                    <Navigation2
                        size={20}
                        className={`absolute -right-3 top-1 rotate-90 text-gray-600 fill-gray-600 ${arrowClass}`}
                    />
                </div>
            </div>

            {/* RIGHT CLICK TOOLTIP (SEPARATE) */}
            {isRightClick && showContext && (
                <div className="absolute right-2 cursor-pointer w-max group top-7 text-xs bg-gray-600 px-4 py-3 rounded z-50" onClick={onContextContentClick}>
                    {rightClickContent ||
                        <div className='flex items-center gap-2'>
                            <img src="/images/icons/upload-cloud.svg" width={16} height={16} alt="upload" />
                            <Text variant='caption' fontWeight='font-medium' className="text-gray-200 group-hover:text-gray-200 text-nowrap">Upload Help Doc</Text>
                        </div>
                    }
                </div>
            )}
        </div>
    );
};

export default TooltipWithArrow;